<template>
    <el-card class="box-card">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item label="申请类型" prop="examine_type">
                <el-select
                    v-model="form.examine_type"
                    placeholder="选择类型"
                    class="examine_typec"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="examine_type in all_examine_type"
                        :key="examine_type.name"
                        :label="examine_type.name"
                        :value="examine_type.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="处理状态" prop="my_state">
                <el-select
                    v-model="form.my_state"
                    placeholder="选择状态"
                    class="statec"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="(v,i) in ['待处理','等待中','已处理']"
                        :key="v"
                        :label="v"
                        :value="i"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="紧急程度" prop="urgent_state">
                <el-select
                    v-model="form.urgent_state"
                    placeholder="选择紧急程度"
                    class="statec"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="(v,i) in ['一般','较急','特急']"
                        :key="v"
                        :label="v"
                        :value="i"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="单号" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="单号搜索"
                    class="namec"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="金额" prop="money">
                <el-input
                    v-model="form.money"
                    placeholder="金额搜索"
                    class="moneyc"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="staff_id">
                <el-select
                    v-model="form.staff_id"
                    placeholder="选择申请人"
                    class="staff_idc"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="staff in AllStaff"
                        :key="staff.name"
                        :label="staff.name"
                        :value="staff.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
                <el-button
                type="success"
                plain
                round
                @click="$emit('approval_select')"
                class="temp_add"
                size="medium"
                >批量审批通过</el-button
            >
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
import { staff_list_request } from '@/network/list.js'

export default {
    name: 'MyExamineSearchBarComponent',
    data() {
        return {
            form: {
                examine_type: '',
                my_state: 0,
                urgent_state: '',
                name: '',
                money: '',
                staff_id: '',
                page: 1,
            },
            AllStaff: []
        }
    },
    computed: {
        all_examine_type() {
            return this.$store.state.examine_type
        }
    },
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        },
        get_all_staff() {
            staff_list_request()
                .then((s) => {
                    if (s.status === 0) {
                        this.AllStaff = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.$message.error(err)
                })
        },
    },
    filters: {},
    created() {
        this.get_all_staff()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>